import React, { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { PrimaryIconButton, SecondaryIconButton } from "../../theme/index";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { useDispatch, useSelector } from "react-redux";
import { modalAction, modalDeleteAction } from "../../redux/reducers/Modal";
import SuccessModal from "../SuccessModal";
import DangerModal from "../DangerModal";
import { Pagination, PaginationItem, Grid } from "@mui/material";
import styled from "@mui/material/styles/styled";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import axios from "axios";
import { saveRoomIdAction } from "../../redux/reducers/Delete";
import { collection, getDocs, query, where } from "firebase/firestore";
import db from "../../config/firebase";

const PaginationGrid = styled(Grid)(
  ({ theme }) => `
    ul{
        justify-content: end
    }

    button:hover{
        background: ${theme.palette.primary.light};
        color: #FFF
    }
`
);

const PaginationItemStyled = styled(PaginationItem)(
  ({ theme }) => `
    svg{
        color: #000;
    }

    button:hover, svg:hover{
        background: ${theme.palette.primary.light};
        color: #FFF
    }
`
);

function createData(id, roomNumber, details, price, category, level, status) {
  return { id, roomNumber, details, price, category, level, status };
}

// const rows = [
//     createData(1, '001', 'Aire acondicionado + TV + Jaccuzi', 80, 'double-bed', 1, true),
//     createData(2, '002', 'Aire acondicionado + TV + Jaccuzi', 40, 'personal', 1, true),
//     createData(3, '003', 'Aire acondicionado + Cama matrimonial + Jaccuzi', 130, 'double-bed', 1, true),
//     createData(4, '004', 'Aire acondicionado + TV + Jaccuzi', 40, 'personal', 1, true),
//     createData(5, '005', 'Aire acondicionado + TV + Jaccuzi', 80, 'double-bed', 2, true),
//     createData(6, '006', 'Aire acondicionado + TV + Jaccuzi', 60, 'double', 2, true),
//     createData(7, '007', 'Aire acondicionado + TV + Jaccuzi', 60, 'junior-suite', 2, true),
//     createData(8, '008', 'Aire acondicionado + TV + Jaccuzi', 160, 'suite', 2, true),
//     createData(9, '009', 'Aire acondicionado + TV + Jaccuzi', 80, 'double-bed', 3, true),
//     createData(10, '010', 'Aire acondicionado + TV + Jaccuzi', 40, 'personal', 3, true),
//     createData(11, '011', 'Aire acondicionado + TV + Jaccuzi', 80, 'double-bed', 3, true),
//     createData(12, '012', 'Aire acondicionado + TV + Jaccuzi', 60, 'double', 3, true),
//     createData(13, '013', 'Aire acondicionado + TV + Jaccuzi', 40, 'personal', 3, true),
//   ];

const Rooms = () => {
  const [clients, setClients] = useState([]);
  const [search, setSearch] = useState([]);
  const [paginations, setPaginations] = useState(0);
  const [initResult, setInitResult] = useState(0);
  const [endResult, setEndResult] = useState(10);
  const [roomData, setRoomData] = useState({});
  const [rowData, setRowData] = useState([]);
  const [page, setPage] = useState(1);
  const searchData = useSelector((state) => state.Search.data);
  const newRoomData = useSelector((state) => state.Create.room);
  const roomToDelete = useSelector((state) => state.Delete.roomId);
  const roomStatusDelete = useSelector((state) => state.Delete.roomStatus);
  const roomToEdit = useSelector((state) => state.Edit.roomEdited);

  useEffect(() => {
    if (newRoomData.roomNumber) {
      let currentClients = [newRoomData, ...clients];
      setClients(currentClients);
    }
  }, [newRoomData]);

  useEffect(() => {
    const petition = async () => {
      const q = query(collection(db, "room"));
      const querySnapshot = await getDocs(q);
      let roomArray = [];
      querySnapshot.forEach((doc) => {
        roomArray.push({ id: doc.id, ...doc.data() });
      });
      addData(roomArray);
    };

    const addData = (data) => {
      setRowData(data.reverse());

      // filter
      if (data.length > 0) {
        const mappingArray = data.filter((item, index) => {
          return index >= initResult && index < endResult ? item : null;
        });

        setClients(mappingArray);
        setPaginations(Math.ceil(data.length / 10));
      }
    };

    petition();
  }, []);

  useEffect(() => {
    
  }, [page]);

  useEffect(() => {
    if (roomToEdit !== {}) {
      let listEdited = clients.map((item) => {
        return item.id == roomToEdit.id ? { ...roomToEdit } : item;
      });

      setClients(listEdited);
    }
  }, [roomToEdit]);

  useEffect(() => {
    if (roomStatusDelete == "SUCCESS") {
      const currentClients = clients.filter((item) => item.id !== roomToDelete);
      setClients(currentClients);
    }
  }, [roomStatusDelete]);

  const handleChange = (event, value) => {
    if (page < value) {
      // aumentar
      setInitResult(initResult + 10);
      setEndResult(endResult + 10);
    } else {
      // disminuir
      setInitResult(initResult - 10);
      setEndResult(endResult - 10);
    }
    setPage(value);
  };

  useEffect(() => {
    if (rowData.length > 0) {
      const textToSearch = searchData.toLowerCase();
      const mappingArray = rowData.filter((item, index) => {
        return index >= initResult && index < endResult ? item : null;
      });

      if (searchData !== "") {
        const filteredElements = rowData.filter(
          (item, index) =>
            item.details.toLowerCase().includes(textToSearch) ||
            item.category.toLowerCase().includes(textToSearch) ||
            item.roomNumber.includes(textToSearch)
        );
        setSearch(filteredElements);
      } else {
        const filteredElements = mappingArray.map((item, index) => item);
        setClients(filteredElements);
      }
    }

    // setPaginations(Math.ceil(rowData.length / 10));
  }, [searchData, initResult, endResult, page]);

  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [modalForm, setModalForm] = useState("");
  const [deleteModal, setDeleteModal] = useState("");
  const modalStatus = useSelector((state) => state.Modal.modalState);
  const deleteModalStatus = useSelector(
    (state) => state.Modal.deleteModalState
  );

  useEffect(() => {
    setShowModal(modalStatus);
    if (!modalStatus) setModalForm("");
  }, [modalStatus]);

  useEffect(() => {
    setShowDeleteModal(deleteModalStatus);
  }, [deleteModalStatus]);

  const editClient = (data) => {
    setModalForm("editRoom");
    setRoomData(data);
    setDeleteModal("");
    dispatch(modalAction());
  };

  const deleteClient = (id) => {
    setModalForm("");
    dispatch(modalDeleteAction());
    setDeleteModal("room");
    dispatch(saveRoomIdAction(id));
  };

  return (
    <>
      {showModal && modalForm !== "" && (
        <SuccessModal view={modalForm} room={roomData} />
      )}
      {showDeleteModal && deleteModal !== "" && (
        <DangerModal view={deleteModal} />
      )}
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Nº</TableCell>
              <TableCell>Detalles</TableCell>
              <TableCell>Precio Estándar</TableCell>
              <TableCell>Precio Express</TableCell>
              <TableCell>Categoría</TableCell>
              <TableCell>Piso</TableCell>
              <TableCell>Status</TableCell>
              <TableCell align="center">Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {searchData !== "" &&
              search.map((row) => (
                <TableRow
                  key={row.roomNumber}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    {row.roomNumber}
                  </TableCell>
                  <TableCell>{row.details}</TableCell>
                  <TableCell>{row.price}</TableCell>
                  <TableCell>
                    {row.expressPrice ? row.expressPrice : "0"}
                  </TableCell>
                  <TableCell>{row.category}</TableCell>
                  <TableCell>{row.level}</TableCell>
                  <TableCell>{row.status}</TableCell>
                  <TableCell style={{ textAlign: "center" }}>
                    {
                      <>
                        <PrimaryIconButton
                          aria-label="delete"
                          sx={{ mx: ".4rem" }}
                          onClick={() => editClient(row)}
                        >
                          <EditIcon />
                        </PrimaryIconButton>
                        <SecondaryIconButton
                          aria-label="delete"
                          onClick={() => deleteClient(row.id)}
                        >
                          <DeleteIcon />
                        </SecondaryIconButton>
                      </>
                    }
                  </TableCell>
                </TableRow>
              ))}

            {searchData == "" &&
              clients.map((row) => (
                <TableRow
                  key={row.roomNumber}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    {row.roomNumber}
                  </TableCell>
                  <TableCell>{row.details}</TableCell>
                  <TableCell>{row.price}</TableCell>
                  <TableCell>
                    {row.expressPrice ? row.expressPrice : "0"}
                  </TableCell>
                  <TableCell>{row.category}</TableCell>
                  <TableCell>{row.level}</TableCell>
                  <TableCell>{row.status}</TableCell>
                  <TableCell style={{ textAlign: "center" }}>
                    {
                      <>
                        <PrimaryIconButton
                          aria-label="delete"
                          sx={{ mx: ".4rem" }}
                          onClick={() => editClient(row)}
                        >
                          <EditIcon />
                        </PrimaryIconButton>
                        <SecondaryIconButton
                          aria-label="delete"
                          onClick={() => deleteClient(row.id)}
                        >
                          <DeleteIcon />
                        </SecondaryIconButton>
                      </>
                    }
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Grid container sx={{ justifyContent: "end", textAlign: "end", mt: 2 }}>
        <PaginationGrid item xs={12}>
          <Pagination
            count={paginations}
            onChange={handleChange}
            renderItem={(item) => (
              <PaginationItemStyled
                components={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                {...item}
              />
            )}
          />
        </PaginationGrid>
      </Grid>
    </>
  );
};

export default Rooms;
